import { GatewayId } from '@pillar-portal/database/dist/enums';
import {
    IpgSystemId,
    IpgSystemIdKey,
    ThirdPartySystemId,
    type SupportedIpgSystemId,
} from '../../third-party-system.enums';

export const CardPointeIpgSystemId = IpgSystemId.CARDPOINTE;
export const CardPointeIpgSystemIdKey = IpgSystemIdKey.CARDPOINTE;
export const CardPointeThirdPartySystemId = ThirdPartySystemId.CARDPOINTE;
export const CardPointeGatewayId = GatewayId.CARDPOINTE;

export function isCardPointeIpgSystemId(systemId: IpgSystemId): systemId is SupportedIpgSystemId {
    return systemId === CardPointeIpgSystemId;
}

export function isCardPointeThirdPartySystemId(
    systemId: ThirdPartySystemId
): systemId is typeof CardPointeThirdPartySystemId {
    return systemId === CardPointeThirdPartySystemId;
}
